const deviceUtil = {
  isMobile (): boolean {
    const userAgentData = (window.navigator as any).userAgentData
    return userAgentData ? (userAgentData.mobile as boolean) : false
  }
}

export default deviceUtil
